export const ANIMATION_DURATION_MS = 500;

export const animationTransition = (...properties: Array<string>) => {
  if (!Boolean(properties)) {
    throw new Error('Must pass one property to transition');
  }
  return properties
    .map(property => `${property} ${ANIMATION_DURATION_MS}ms cubic-bezier(0.23, 1, 0.32, 1) 0s`)
    .join(', ');
};

export const animationTransitionWithDuration = (
  properties: Array<string>,
  duration: number = ANIMATION_DURATION_MS
) => {
  if (!Boolean(properties)) {
    throw new Error('Must pass one property to transition');
  }
  return properties.map(property => `${property} ${duration}ms cubic-bezier(0.23, 1, 0.32, 1) 0s`).join(', ');
};
